import { render, staticRenderFns } from "./PurchasesInvoiceStatusBadge.vue?vue&type=template&id=43af2dc8"
import script from "./PurchasesInvoiceStatusBadge.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports